module.exports = __webpack_public_path__ + "media/images/showcase_2_img_1-11556e50.jpg";